import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';
import i18n from '@/utils/i18n';

interface ParcelLostDialogProps {
  open: boolean;
  loading: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function ParcelLostDialog({
  open,
  loading,
  onOpenChange,
  onConfirm,
}: ParcelLostDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{i18n.t('Order:parcelLostDialogTitle')}</DialogTitle>
          <DialogDescription>
            {i18n.t('Order:parcelLostDialogDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogBody className="tw:flex tw:flex-col tw:gap-3">
          <ul className="tw:list-disc tw:pl-5 tw:text-sm tw:flex tw:flex-col tw:gap-1">
            <li>{i18n.t('Order:parcelLostDialogContainers')}</li>
            <li>{i18n.t('Order:parcelLostDialogCompleted')}</li>
            <li>{i18n.t('Order:parcelLostDialogIrreversible')}</li>
          </ul>
          <Alert variant="warning">
            <AlertDescription>
              {i18n.t('Order:parcelLostDialogPartialHint')}
            </AlertDescription>
          </Alert>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={loading}>
              {i18n.t('Common:cancel')}
            </Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading && <Spinner />}
            {i18n.t('Order:parcelLostConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
